import { SaveDynamicMetaState } from 'types/store/saveDynamicFilter';
import {
  createClearAction,
  createUpdateAction,
} from 'utils/Redux';

const ns = 'SAVE_DYNAMIC_FILTER_LIBRARY';
const asyncAction = createUpdateAction<SaveDynamicMetaState>(ns);

const clearAction = createClearAction(ns);

const saveDynamicFilterLibraryActions = {
  ...asyncAction,
  ...clearAction,
};

export default saveDynamicFilterLibraryActions;
